import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableWrapper } from 'app/components/tables/BaseTableReport/styles'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { FONT_SIZE, FONT_WEIGHT, PADDING } from 'parkway-web-common'
import styled from 'styled-components'

export const RootWrapper = styled.div`
  padding: 0px ${PADDING.md} ${PADDING.md} ${PADDING.md};
`

export const HeadPageWrapper = styled(HeaderPage)`
  padding-bottom: 0px !important;
`

export const BaseTableReport = styled(BaseTableWrapper)`
  .ant-table-thead > tr > th {
    text-align: center !important;
    font-size: ${FONT_SIZE.xxs} !important;
    font-weight: ${FONT_WEIGHT.semibold} !important;
    color: ${convertedVariables.primaryColor};
    opacity: 0.7;
  }
  .ant-table-thead > tr > th {
    text-align: left !important;
  }
  .ant-table-tbody .ant-table-cell {
    align-content: start;
  }

  // .ant-table-thead > tr > th:last-child {
  //   text-align: right !important;
  // }
`
export const ServiceText = styled(BaseText)`
  font-size: ${FONT_SIZE.xs} !important;
  font-weight: ${FONT_WEIGHT.medium} !important;
  color: ${convertedVariables.primaryColor};
  opacity: 0.5;
  margin-bottom: 8px;
  padding-left: 8px;
`
export const SeeMoreButton = styled.div`
  font-size: ${FONT_SIZE.xxs} !important;
  font-weight: ${FONT_WEIGHT.medium} !important;
  color: ${convertedVariables.primaryColor};
  opacity: 0.5;
  margin-bottom: 8px;
  padding-left: 8px;
  text-align: right;
  cursor: pointer;
`
export const DayContainer = styled(BaseSpace)``
